import React from 'react';
import Tooltip, { TooltipProps } from '@material-ui/core/Tooltip';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  arrow: {
    color: '#333333',
  },
  tooltip: {
    border: '1px solid #333333',
    backgroundColor: '#333333',
    fontSize: 14,
    lineHeight: '18px',
    padding: 10,
    fontFamily: 'Source Sans Pro',
    fontWeight: 'normal',
    textAlign: 'center',
  },
});

const StyledTooltip = (props: TooltipProps) => {
  const classes = useStyles(props);
  return <Tooltip arrow classes={classes} {...props} data-testid="tool-tip" />;
};
export default StyledTooltip;
